export enum SeatStatuses {
  BLOCKED = 'SEAT_BLOCKED',
  FREE = 'SEAT_FREE',
  RESERVED = 'SEAT_RESERVED',
  SOLD = 'SEAT_SOLD',
  NOTED = 'SEAT_NOTED',
}
